import {AvailabilityStateSlice} from '../slices/AvailabilityStateSlice';

export const availabilityBannerToggled = (
  state: AvailabilityStateSlice,
  {
    payload,
  }: {
    payload: {
      isBannerVisible: boolean;
    };
  },
): void => {
  state.isBannerVisible = payload.isBannerVisible;
};
